import Link from 'next/link'

export default function CityLinks({ cities, showAll = false, limit = 9 }: { cities: any[], showAll?: boolean, limit?: number }) {
  const displayCities = showAll ? cities : cities.slice(0, limit)

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8">
        {displayCities.map((c) => (
          <Link
            key={c.slug}
            href={`/${c.slug}`}
            className="block p-4 sm:p-6 border border-gray-200 rounded-lg hover:shadow-lg hover:border-[#0066CC] transition-all duration-300 transform hover:-translate-y-1"
          >
            <h3 className="font-semibold text-lg text-gray-900">{c.name}</h3>
            <p className="text-sm text-gray-600 mt-2">{c.description}</p>
          </Link>
        ))}
      </div>

      {!showAll && cities.length > limit && (
        <div className="text-center">
          <Link
            href="/cities"
            className="inline-block bg-[#0066CC] hover:bg-[#004BA6] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300"
          >
            Alle {cities.length} Standorte anzeigen
          </Link>
        </div>
      )}
    </div>
  )
}
